<template>
  <div id="page-top" class="h-100 w-100">
    <div id="wrapper">
      <!-- Sidebar -->
      <ul
        class="navbar-nav bg-facpya sidebar sidebar-dark accordion"
        id="accordionSidebar"
      >
        <!-- Sidebar - Brand -->
        <a v-on:click.prevent="Nada" class="sidebar-brand d-flex" href="">
          <div
            v-if="menu_oculto"
            class="d-flex justify-content-center"
            style="margin-top: -15px;"
          >
            <span style="font-size: 9px; text-align: center; width: 100%;">
              RILEMWeek
            </span>
          </div>
          <div
            v-else
            style="font-size: 15px; text-align: center;"
            class="d-flex justify-content-center w-100"
          >
            RILEMWeek
          </div>
        </a>

        <!-- Divider -->
        <hr class="sidebar-divider my-0" />

        <!-- Nav Item - Dashboard -->
        <li
          class="nav-item active"
          v-if="usuario.perfil.nombre !== 'Participante'"
        >
          <a v-on:click.prevent="Ruta('Dashboard')" class="nav-link" href="">
            <i class="fas fa-fw fa-tachometer-alt"></i>
            <span>Dashboard</span></a
          >
        </li>

        <!-- Heading -->
        <div class="sidebar-heading mt-2">
          Admin
        </div>

        <!-- Nav Item - Tables -->
        <li v-if="usuario.perfil.permisos.vacantes.consultar" class="nav-item">
          <a v-on:click.prevent="Ruta('Vacantes')" class="nav-link" href="">
            <i class="fas fa-list"></i>
            <span>Vacantes</span>
          </a>
        </li>

        <li
          v-if="
            usuario.cliente.id != null &&
              usuario.cliente.id != 'null' &&
              usuario.perfil.permisos.tarjeta.consultar
          "
          class="nav-item"
        >
          <a
            v-on:click.prevent="
              Ruta('Empresa', { idcliente: usuario.cliente.id })
            "
            class="nav-link "
            href=""
          >
            <i class="fas fa-address-card"></i>
            <span>Tarjeta Información</span></a
          >
        </li>

        <li v-if="usuario.perfil.permisos.empresas.consultar" class="nav-item">
          <a v-on:click.prevent="Ruta('Empresas')" class="nav-link " href="">
            <i class="fas fa-users"></i>
            <span>Empresas</span></a
          >
        </li>

        <li
          v-if="
            usuario.cliente.id != null &&
              usuario.cliente.id != 'null' &&
              usuario.perfil.permisos.chat.consultar
          "
          class="nav-item"
        >
          <a v-on:click.prevent="Ruta('Chat')" class="nav-link " href="">
            <i class="fas fa-comments"></i>
            <span>Chat</span></a
          >
        </li>

        <div class="sidebar-heading mt-4">
          Config
        </div>

        <li v-if="usuario.perfil.permisos.usuarios.consultar" class="nav-item">
          <a v-on:click.prevent="Ruta('Usuarios')" class="nav-link" href="">
            <i class="fas fa-user-friends"></i>
            <span>Usuarios</span></a
          >
        </li>

        <li v-if="usuario.perfil.permisos.perfiles.consultar" class="nav-item">
          <a v-on:click.prevent="Ruta('Perfiles')" class="nav-link " href="">
            <i class="fas fa-user-cog"></i>
            <span>Perfiles</span></a
          >
        </li>

        <!-- Divider -->
        <hr class="sidebar-divider d-none d-md-block" />

        <!-- Sidebar Toggler (Sidebar) -->
        <div class="text-center d-none d-md-inline">
          <button
            v-on:click="MostrarMenu"
            class="rounded-circle border-0"
            id="sidebarToggle"
          ></button>
        </div>
      </ul>
      <!-- End of Sidebar -->

      <!-- Content Wrapper -->
      <div id="content-wrapper" class="d-flex flex-column">
        <!-- Main Content -->
        <div id="content">
          <!-- Topbar -->
          <nav
            class="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow"
          >
            <!-- Sidebar Toggle (Topbar) -->
            <button
              v-on:click="MostrarMenu"
              id="sidebarToggleTop"
              class="btn btn-link d-md-none rounded-circle mr-3"
            >
              <i class="fa fa-bars"></i>
            </button>

            <!-- Topbar Search -->
            <form
              v-on:submit.prevent="Nada"
              class="d-none d-sm-inline-block form-inline mr-auto ml-md-3 my-2 my-md-0 mw-100 navbar-search"
            >
              <div class="input-group">
                <input
                  type="text"
                  class="form-control bg-light border-0 small"
                  placeholder="Buscar..."
                  aria-label="Search"
                  aria-describedby="basic-addon2"
                />
                <div class="input-group-append">
                  <button
                    v-on:click.prevent="Nada"
                    class="btn btn-facpya"
                    type="button"
                  >
                    <i class="fas fa-search fa-sm"></i>
                  </button>
                </div>
              </div>
            </form>

            <!-- Topbar Navbar -->
            <ul class="navbar-nav ml-auto">
              <!-- Nav Item - Alerts -->
              <li class="nav-item dropdown no-arrow mx-1">
                <a
                  v-on:click.prevent="Nada"
                  class="nav-link dropdown-toggle"
                  href=""
                  id="alertsDropdown"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  {{
                    usuario.cliente.nombre == ""
                      ? usuario.perfil.nombre
                      : usuario.cliente.nombre
                  }}
                </a>
              </li>

              <div class="topbar-divider d-none d-sm-block"></div>

              <!-- Nav Item - User Information -->
              <li class="nav-item dropdown no-arrow">
                <a
                  class="nav-link dropdown-toggle"
                  href="#"
                  id="userDropdown"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <span class="mr-2 d-none d-lg-inline text-gray-600 small">
                    {{ usuario.displayName }}
                  </span>
                  <img
                    class="img-profile rounded-circle"
                    src="static/img/undraw_profile.svg"
                  />
                </a>
                <!-- Dropdown - User Information -->
                <div
                  class="dropdown-menu dropdown-menu-right shadow animated--grow-in"
                  aria-labelledby="userDropdown"
                >
                  <a v-on:click.prevent="Nada" class="dropdown-item" href="">
                    {{ usuario.email }}
                  </a>
                  <div class="dropdown-divider"></div>
                  <a v-on:click.prevent="Salir" class="dropdown-item" href="">
                    <i
                      class="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"
                    ></i>
                    Salir
                  </a>
                </div>
              </li>
            </ul>
          </nav>
          <!-- End of Topbar -->

          <!-- Begin Page Content -->
          <router-view v-if="usuario.id != null && usuario.id != 'null'" />
          <!-- /.container-fluid -->
        </div>
        <!-- End of Main Content -->

        <!-- Footer -->
        <footer class="sticky-footer bg-white">
          <div class="container my-auto">
            <div class="copyright text-center my-auto">
              <span>Copyright &copy; UANL 2021</span>
            </div>
          </div>
        </footer>
        <!-- End of Footer -->
      </div>
      <!-- End of Content Wrapper -->
    </div>
    <a class="scroll-to-top rounded" href="#page-top">
      <i class="fas fa-angle-up"></i>
    </a>
  </div>
</template>

<script>
import { auth } from "@/firebase.js";
import { mapState } from "vuex";
export default {
  data() {
    return {
      menu_oculto: false
    };
  },
  methods: {
    Salir() {
      auth.signOut().catch(error => {
        swal(
          "Problemas para cerrar sesión",
          "Favor de intentarlo mas tarde",
          "error"
        );
      });
    },
    Ruta(name, params) {
      let parametros = {};
      if (params != undefined) {
        parametros = params;
      }
      this.$router.push({ name: name, params: parametros });
    },
    Nada() {},
    MostrarMenu() {
      $("body").toggleClass("sidebar-toggled");
      $(".sidebar").toggleClass("toggled");
      if ($(".sidebar").hasClass("toggled")) {
        $(".sidebar .collapse").collapse("hide");
        this.menu_oculto = true;
      } else {
        this.menu_oculto = false;
      }
    },
    Configuracion() {
      // Close any open menu accordions when window is resized below 768px
      $(window).resize(function() {
        if ($(window).width() < 768) {
          $(".sidebar .collapse").collapse("hide");
        }

        // Toggle the side navigation when window is resized below 480px
        if ($(window).width() < 480 && !$(".sidebar").hasClass("toggled")) {
          $("body").addClass("sidebar-toggled");
          $(".sidebar").addClass("toggled");
          $(".sidebar .collapse").collapse("hide");
        }
      });

      // Prevent the content wrapper from scrolling when the fixed side navigation hovered over
      $("body.fixed-nav .sidebar").on(
        "mousewheel DOMMouseScroll wheel",
        function(e) {
          if ($(window).width() > 768) {
            var e0 = e.originalEvent,
              delta = e0.wheelDelta || -e0.detail;
            this.scrollTop += (delta < 0 ? 1 : -1) * 30;
            e.preventDefault();
          }
        }
      );
    }
  },
  computed: {
    ...mapState(["usuario"])
  },
  mounted() {
    this.Configuracion();
    if (
      document.querySelector("#accordionSidebar").classList.contains("toggled")
    ) {
      this.menu_oculto = true;
    } else {
      this.menu_oculto = false;
    }
  },
  created() {}
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Menu.vue